import type { MeResponse } from '@store/entities/me/types';
import { useMediaListResponse } from '@store/entities/media';
import { useMePermissionsResponse } from '@store/entities/mePermission';
import { useMeRolesResponse } from '@store/entities/meRole';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

type MeStoreInput = Partial<Pick<MeResponse, 'permissions' | 'roles' | 'avatar'>>;

export const useMeResponse = () => {
  const { setPermissions, setRoles, setMedia } = useSetters();
  const setMe = useAtomCallback(
    useCallback(
      (_get, _set, data: MeStoreInput) => {
        setPermissions(data);
        setRoles(data);
        setMedia(data);
      },
      [setPermissions]
    )
  );

  return {
    setMe,
  };
};

const useSetters = () => {
  const { setMePermissions } = useMePermissionsResponse();
  const { setMeRoles } = useMeRolesResponse();
  const { setMediaListFromRespone } = useMediaListResponse();

  const setPermissions = useAtomCallback(
    useCallback(
      (_get, _set, data: MeStoreInput) => {
        if (data.permissions) setMePermissions(data.permissions);
      },
      [setMePermissions]
    )
  );
  const setMedia = useAtomCallback(
    useCallback(
      (_get, _set, data: MeStoreInput) => {
        if (data.avatar) setMediaListFromRespone([data.avatar]);
      },
      [setMediaListFromRespone]
    )
  );

  const setRoles = useAtomCallback(
    useCallback(
      (_get, _set, data: MeStoreInput) => {
        if (data.roles) setMeRoles(data.roles);
      },
      [setMeRoles]
    )
  );

  return {
    setPermissions,
    setRoles,
    setMedia,
  };
};
